// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import {
  assignDevice,
  unAssignDevice,
  downloadLicence
} from "../../actions/userActions";
import {
  companyAssignDevice,
  companyUnassignDevice,
  companyDownloadLicence,
  getLicenceFileUrl
} from "../../actions/companyActions";

import {
  createLicenceEmailNotification,
  fetchLicenceEmailNotification,
  updateIsNotified,
  removeLicenceEmailNotification,
  updateLicenceEmailNotification,
  clearLicenceEmailNotification
} from "../../actions/emailNotificationActions";

import {
  deleteLicence,
  deleteLicenceHistory
} from "../../../admin/actions/licenceAdminActions";
import { hasPrincipal } from "../../../global/containers/UserAuth";
import { buildCompanyInfoJson } from "../../components/companies/CompileCompanytoJson";
import LicenceItem from "../../components/licences/LicenceItem";

type LicenceItemReduxPropsType = {
  licence: { [key: string]: * },
  displayCompany?: boolean, // for Admin Licences Page
  isAdmin?: boolean,
  isForUser?: boolean, //for My Licences Page
  canEdit?: boolean,
  openSnackbar?: Function,
  user: { [key: string]: * },
  company: { [key: string]: * },
  actions: {
    assignDevice: Function,
    unAssignDevice: Function,
    fetchLicenceEmailNotification: function,
    addEmailNotification: function,
    removeEmailNotification: function,
    updateEmailNotification: function,
    patchEmailNotification: function,
    downloadLicence: Function,
    companyAssignDevice: Function,
    companyUnassignDevice: Function,
    companyDownloadLicence: Function,
    getLicenceFileUrl: Function,
    deleteLicence: Function
  }
};

class LicenceItemRedux extends Component<LicenceItemReduxPropsType, *> {
  componentDidMount() {
    const { licence, actions } = this.props;
    if (licence && licence.uuid) {
      actions.fetchLicenceEmailNotification(licence.uuid);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.licence &&
      prevProps.licence &&
      this.props.licence.uuid !== prevProps.licence.uuid
    ) {
      this.props.actions.clearLicenceEmailNotification();
      this.props.actions.fetchLicenceEmailNotification(this.props.licence.uuid);
    }
  }
  assignDevice = (
    deviceid: string,
    licenceid: string,
    licenceuuid: string,
    doneCall: Function,
    failCall: Function
  ): * => {
    if (this.props.isForUser) {
      this.props.actions.assignDevice(
        deviceid,
        licenceid,
        licenceuuid,
        doneCall,
        failCall
      );
    } else {
      this.props.actions.companyAssignDevice(
        deviceid,
        licenceid,
        doneCall,
        failCall,
        this.props.isAdmin && !this.props.displayCompany
          ? this.props.licence.company.id
          : null,
        this.props.displayCompany
      );
    }
  };

  unAssignDevice = (
    deviceid: string,
    licenceid: string,
    licenceuuid: string,
    doneCall: Function,
    failCall: Function
  ): * => {
    if (this.props.isForUser) {
      this.props.actions.unAssignDevice(
        deviceid,
        licenceid,
        licenceuuid,
        doneCall,
        failCall
      );
    } else {
      this.props.actions.companyUnassignDevice(
        deviceid,
        licenceid,
        doneCall,
        failCall,
        this.props.isAdmin && !this.props.displayCompany
          ? this.props.licence.company.id
          : null,
        this.props.displayCompany
      );
    }
  };

  downloadLicence = (
    deviceid: string,
    licenceid: string,
    isOld: boolean,
    doneCall: Function,
    failCall: Function
  ): * => {
    if (this.props.isForUser) {
      this.props.actions.downloadLicence(deviceid, doneCall, failCall);
    } else {
      this.props.actions.companyDownloadLicence(
        deviceid,
        licenceid,
        isOld,
        doneCall,
        failCall
      );
    }
  };

  downloadPOFile = (
    licenceId: string,
    licenceExtentId: string | null,
    doneCall: Function,
    failCall: Function
  ): * => {
    this.props.actions.getLicenceFileUrl(
      licenceId,
      licenceExtentId,
      doneCall,
      failCall
    );
  };

  deleteLicence = (
    licenceId: string,
    licenceUuid: string,
    doneCallback: Function,
    failCallBack: Function
  ): * => {
    this.props.actions.deleteLicence(
      licenceId,
      licenceUuid,
      doneCallback,
      failCallBack,
      this.props.isAdmin && !this.props.displayCompany
        ? this.props.licence.company.id
        : null,
      null,
      this.props.isAdmin && this.props.displayCompany
    );
  };

  deleteLicenceHistory = (
    historyId: string,
    doneCallback: Function,
    failCallBack: Function
  ): * => {
    this.props.actions.deleteLicenceHistory(
      this.props.licence.id,
      historyId,
      doneCallback,
      failCallBack,
      this.props.isAdmin
        ? this.props.displayCompany
          ? "adminLicence"
          : "adminCompany"
        : "company",
      this.props.isAdmin ? this.props.licence.company.id : this.props.company.id
    );
  };

  handleEmailNotificationSubmit = (data) => {
    const notification = this.props.emailNotification;
    if (notification && notification.uuid) {
      const onlyIsNotifiedChanged =
        data.is_notified !== notification.is_notified &&
        data.email_list.toString() === notification.email_list.toString() &&
        data.days === notification.days;

      if (onlyIsNotifiedChanged) {
        this.props.actions.updateIsNotified(notification.uuid, data.is_notified);
      } else {
        this.props.actions.updateLicenceEmailNotification(notification.uuid, {
          ...notification,
          email_list: data.email_list,
          days: data.days,
          is_notified: data.is_notified,
        });
      }
    } else {
      this.props.actions.createLicenceEmailNotification({
        licence_uuid: this.props.licence.uuid,
        email_list: data.email_list,
        days: data.days,
        is_notified: data.is_notified,
      });
    }
  };

  handleEmailNotificationDelete = (uuid: string) => {
    this.props.actions.removeLicenceEmailNotification(uuid);
  };
  render(): React$Element<*> {
    const isLicenceAdmin = hasPrincipal(
      "licence_delegater",
      this.props.user.groups
    );
    const isImagusAdmin =
      hasPrincipal("imagus_admin", this.props.user.groups) &&
      !this.props.isForUser;
    const company = this.props.isAdmin
      ? this.props.licence.company
      : buildCompanyInfoJson(this.props.company);

    // Get notification from Redux (assumes reducer is mounted at state.v3account.emailNotification)
    const notification = this.props.emailNotification;

    return (
      <LicenceItem

        licence={this.props.licence}
        company={company}
        isAdmin={this.props.isAdmin}
        displayCompany={this.props.displayCompany}
        canEdit={this.props.canEdit}
        openSnackbar={this.props.openSnackbar}
        isLicenceAdmin={isLicenceAdmin}
        isImagusAdmin={isImagusAdmin}
        assignDevice={this.assignDevice}
        unAssignDevice={this.unAssignDevice}
        downloadLicence={this.downloadLicence}
        downloadPOFile={this.downloadPOFile}
        deleteLicence={this.deleteLicence}
        deleteLicenceHistory={this.deleteLicenceHistory}
        emailNotification={notification}
        onEmailNotificationSubmit={this.handleEmailNotificationSubmit}
        removeLicenceEmailNotification={this.handleEmailNotificationDelete}
      />
    );
  }
}

const mapStateToProps = (state: StateType): * => ({
  user: state.v3account.user,
  company: state.v3account.company,
  emailNotification: state.v3account.emailNotification && state.v3account.emailNotification.notification
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators(
    {
      assignDevice,
      unAssignDevice,
      downloadLicence,
      companyAssignDevice,
      companyUnassignDevice,
      companyDownloadLicence,
      getLicenceFileUrl,
      createLicenceEmailNotification,
      fetchLicenceEmailNotification,
      updateIsNotified,
      removeLicenceEmailNotification,
      updateLicenceEmailNotification,
      clearLicenceEmailNotification,
      updateIsNotified,
      deleteLicence,
      deleteLicenceHistory
    },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LicenceItemRedux);
